import { useEffect, useState } from "react";
import { adminHttp } from "@/lib/api";
import { Loader2, Mail, Phone } from "lucide-react";

export default function LeadsPanel() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminHttp.get("/admin/leads").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  const fmt = (iso) => {
    if (!iso) return "";
    const d = new Date(iso);
    return d.toLocaleString("en-AE", { dateStyle: "medium", timeStyle: "short" });
  };

  return (
    <div data-testid="admin-leads-panel">
      <div className="flex items-end justify-between mb-10">
        <div>
          <div className="underline-label mb-2">Incoming</div>
          <h2 className="font-display text-3xl text-[#1c1c1c]">Leads</h2>
        </div>
        <div className="text-[11px] uppercase tracking-[0.28em] text-[#6a6259]">
          {items.length} total
        </div>
      </div>

      {loading ? (
        <div className="flex items-center gap-2 text-[#6a6259] text-sm">
          <Loader2 size={14} className="animate-spin" /> Loading…
        </div>
      ) : items.length === 0 ? (
        <div className="text-[#6a6259] text-sm">No leads yet. Contact-form submissions will appear here.</div>
      ) : (
        <div className="space-y-3">
          {items.map((l) => (
            <div
              key={l.id}
              data-testid={`admin-lead-row-${l.id}`}
              className="grid grid-cols-12 gap-4 p-5 border border-[#1c1c1c]/10 bg-white/70 hover:border-[#c5a059]/40 transition-colors"
            >
              <div className="col-span-12 md:col-span-3">
                <div className="font-display text-xl text-[#1c1c1c]">{l.full_name}</div>
                <div className="text-[10px] uppercase tracking-[0.28em] text-[#6a6259] mt-2">{fmt(l.created_at)}</div>
              </div>
              <div className="col-span-12 md:col-span-3 space-y-1.5">
                <a href={`mailto:${l.email}`} className="flex items-center gap-2 text-sm text-[#1c1c1c] hover:text-[#c5a059]">
                  <Mail size={13} className="text-[#c5a059]" /> {l.email}
                </a>
                {l.phone && (
                  <a href={`tel:${l.phone}`} className="flex items-center gap-2 text-sm text-[#6a6259] hover:text-[#c5a059]">
                    <Phone size={13} className="text-[#c5a059]" /> {l.phone}
                  </a>
                )}
              </div>
              <div className="col-span-12 md:col-span-2">
                {l.budget_range && (
                  <div className="underline-label text-[#c5a059]">{l.budget_range}</div>
                )}
                {l.interest && (
                  <div className="text-[11px] text-[#6a6259] mt-1">{l.interest}</div>
                )}
              </div>
              <div className="col-span-12 md:col-span-4 text-sm text-[#1c1c1c]/85 leading-relaxed border-l border-[#1c1c1c]/12 pl-5">
                {l.message}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
